// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Compliance'"></sub-header>
  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#profile-config-tab" data-toggle="tab">
          <i ng-show="\$ctrl.profileForm.\$invalid" class="icon icon-warning-sign"></i>
          Profile
        </a>
      </li>
      <li ng-if="\$ctrl.isDisplayRiskProfiling">
        <a data-target="#risk-profiling-config-tab" data-toggle="tab">
          <i ng-show="\$ctrl.riskProfilingForm.\$invalid" class="icon icon-warning-sign"></i>
          Risk Profiling
        </a>
      </li>
      <li>
        <a data-target="#red-flag-config-tab" data-toggle="tab">
          <i ng-show="\$ctrl.redFlagForm.\$invalid" class="icon icon-warning-sign"></i>
          Red Flags
        </a>
      </li>
    </ul>
  </div>
  <form name="\$ctrl.mainForm">
    <div class="tab-content">
      <div id="profile-config-tab" class="tab-pane active">
        <compliance-config-profile-section
          ng-form="\$ctrl.profileForm"
          compliance-config="\$ctrl.complianceConfig">
        </compliance-config-profile-section>
        <div class="clearfix"></div>

        <div class="compliance-config__control-buttons buttons">
          <button class="btn btn-primary"
                  ng-disabled="\$ctrl.mainForm.\$invalid"
                  command-access="UpdateComplianceConfig"
                  ng-click="\$ctrl.saveConfig()">Save
          </button>
          <button class="btn btn-info"
                  ng-click="\$ctrl.reload()">Discard Changes
          </button>
        </div>
      </div>
      <div ng-if="\$ctrl.isDisplayRiskProfiling"
           id="risk-profiling-config-tab" class="tab-pane">
        <compliance-list-view
          ng-form="\$ctrl.riskProfilingForm">
        </compliance-list-view>
      </div>
      <div id="red-flag-config-tab" class="tab-pane">
        <compliance-config-redflag-section
          ng-if="\$ctrl.complianceConfig && \$ctrl.nonCommensurateConfig"
          ng-form="\$ctrl.redFlagForm"
          compliance-config="\$ctrl.complianceConfig"
          non-commensurate-config="\$ctrl.nonCommensurateConfig"
          voluminous-aggregate-transaction-config="\$ctrl.voluminousAggregateTransactionConfig"
        >
        </compliance-config-redflag-section>
        <div class="clearfix"></div>

        <div class="compliance-config__control-buttons buttons">
          <button class="btn btn-primary"
                  ng-disabled="\$ctrl.mainForm.\$invalid"
                  command-access="UpdateComplianceConfig"
                  ng-click="\$ctrl.saveConfig()">Save
          </button>
          <button class="btn btn-info"
                  ng-click="\$ctrl.reload()">Discard Changes
          </button>
        </div>
      </div>
    </div>
  </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/compliance-config.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;